<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 198.565"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M53.59 114.654c-3.666,-28.822 -5.023,-39.936 0.861,-80.535 -2.554,-9.131 -9.916,43.167 -5.504,82.534 1.179,-0.596 2.469,-1.015 4.643,-1.999z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M52.592 177.445c2.478,-0.597 5.072,-0.506 7.785,0.271 3.071,0.881 6.293,2.642 9.666,5.284 -5.942,6.921 -12.752,11.622 -17.284,11.809 -3.434,0.142 -8.355,-2.15 -13.348,-5.98 3.944,-6.422 8.337,-10.217 13.181,-11.384z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M45.918 149.745c-0.442,14.173 1.784,23.407 6.674,27.7 -4.844,1.167 -9.237,4.962 -13.181,11.384 -9.018,-6.917 -18.272,-18.851 -19.43,-30.526 -0.613,-6.174 1.465,-11.808 5.001,-16.556 0.634,-0.851 1.315,-1.673 2.035,-2.465 2.353,7.66 7.828,10.854 18.901,10.463z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M52.592 177.445c-4.89,-4.293 -7.116,-13.527 -6.674,-27.7 3.186,-0.113 6.837,-0.523 11.01,-1.209 0.307,8.083 1.457,17.81 3.449,29.18 -2.713,-0.777 -5.307,-0.868 -7.785,-0.271z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M56.928 148.536c-4.173,0.686 -7.824,1.096 -11.01,1.209 -11.073,0.391 -16.548,-2.803 -18.901,-10.463 7.069,-7.768 17.967,-12.599 25.999,-12.599 8.839,0 18.585,2.504 24.316,10.502 -4.137,5.771 -10.124,9.46 -16.715,10.699 -1.273,0.239 -2.502,0.457 -3.689,0.652z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M60.377 177.716c-1.992,-11.37 -3.142,-21.097 -3.449,-29.18 1.187,-0.195 2.416,-0.413 3.689,-0.652 6.591,-1.239 12.578,-4.928 16.715,-10.699 0.224,0.313 0.441,0.634 0.653,0.963 2.59,4.037 4.216,9.361 4.338,16.3 0,10.151 -5.59,20.759 -12.28,28.552 -3.373,-2.642 -6.595,-4.403 -9.666,-5.284z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M82.323 154.448c-0.385,-21.996 -15.89,-27.765 -29.307,-27.765 -13.418,0 -34.835,13.481 -33.035,31.62 1.799,18.14 23.141,36.904 32.778,36.506 9.636,-0.398 29.564,-21.194 29.564,-40.361zm-57.341 -12.701c4.896,-36.432 7.313,-61.124 7.252,-74.077 1.568,-34.018 6.545,-48.622 11.843,-53.541 3.975,-3.69 6.455,-3.337 8.738,2.444 2.238,-3.926 3.799,-3.121 7.07,0.771 7.262,8.641 11.031,26.608 9.178,55.85 -0.365,6.844 0.194,32.54 8.922,64.954"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
